module.exports = __webpack_public_path__ + "c8fc4eeb.ttf";